export const systemCheckValueMap = {
  "sc state": ["Initializing", "Ready", "Running", "Fault"],
  "md state": [
    "Initializing",
    "Calibrating",
    "Running",
    "Motor Over speed",
    "Output Disabling",
    "Output Disabled",
    "Shutting Down",
    "Waiting",
  ],
  "bms state": ["Initializing", "Authenticating", "Running", "Shutting Down", "Fault"],
  "vehicle state": [
    "Offline",
    "Available",
    "Reserved",
    "Fault",
    "Unavailable",
    "Operator",
    "Self Check",
    "Firmware Update",
    "Out of Service",
    "Charging",
  ],
};